var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVehicle6(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 149.155,
    height: 92.814,
    viewBox: "0 0 149.155 92.814",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_756",
    "data-name": "Group 756",
    transform: "translate(-965.564 -3328.244)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_324",
    "data-name": "Group 324",
    transform: "translate(965.564 3328.244)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11714",
    "data-name": "Path 11714",
    d: "M1248.8,448.252c-1.879,6.375-.556,8.316,5.614,8.339q20.3.075,40.6.005c4.856-.017,6.339-1.463,6.357-6.369q.087-25.145-.009-50.29c-.021-5.439-1.747-6.723-8.051-6.018v20.593q0,13.149,0,26.3c-.011,6.891-.543,7.434-7.27,7.438C1273.6,448.258,1261.151,448.252,1248.8,448.252Z",
    transform: "translate(-1176.309 -393.474)",
    fill: "#4A4A4A"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11715",
    "data-name": "Path 11715",
    d: "M1317.555,470.758c-1.409-6.18-5.146-9.084-12-9.111-15.215-.06-30.432.005-45.648.017-7.684.006-15.37-.091-23.053.042-6.175.108-9.665,2.993-11.2,9.052Z",
    transform: "translate(-1170.107 -393.474)",
    fill: "#F26A1B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11716",
    "data-name": "Path 11716",
    d: "M1300.839,393.509c-10.312,0-20.114-.144-29.9.151-1.512.045-4.022,1.9-4.284,3.26-3.153,16.377-5.969,32.819-9,49.935h14.007c8.3,0,16.6-.032,24.9.016,2.651.016,4.349-.509,4.327-3.792C1300.781,426.8,1300.839,410.52,1300.839,393.509Zm-3.825,9.226v38.714H1259.75c2.118-12.53,4.138-24.725,6.341-36.887.135-.745,1.724-1.736,2.648-1.748C1278.073,402.684,1287.41,402.735,1297.014,402.735Z",
    transform: "translate(-1185.433 -393.474)",
    fill: "#4A4A4A"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11717",
    "data-name": "Path 11717",
    d: "M1226.815,476.563c.571,6.007,3.734,9.573,9.512,9.611q35.086.225,70.174.012c5.8-.034,8.956-3.465,9.759-9.65-2.4-.815-3.927-.755-5.356,2.119-2.362,4.752-7.854,4.574-10.68.041-2.274-3.647-4.05-3.672-6.285-.089-2.948,4.728-8.1,4.632-11.036-.2-1.912-3.15-3.981-3.23-5.81-.224-3.149,5.174-8.1,5.266-11.174.207-1.947-3.2-3.695-3.186-5.66.051-2.934,4.83-8.038,4.89-11.026.128-2.214-3.529-4.005-3.479-6.351.177-2.893,4.506-8.053,4.475-10.819-.064C1230.426,475.991,1230.426,475.991,1226.815,476.563Z",
    transform: "translate(-1169.966 -393.474)",
    fill: "#F26A1B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11718",
    "data-name": "Path 11718",
    d: "M1336.342,459.681l-26.5-38.029-7.178,5c7.784,11.175,15.388,22.139,23.09,33.035a3.411,3.411,0,0,0,2.6,1.127C1330.783,460.654,1333.184,460.158,1336.342,459.681Z",
    transform: "translate(-1265.899 -393.474)",
    fill: "#4A4A4A"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11719",
    "data-name": "Path 11719",
    d: "M1358.518,432.77l-7.644,1.664c0,7.081-.073,14.089.1,21.092a3.59,3.59,0,0,0,2.1,2.419c6.309,2.342,12.689,4.494,20.042,7.053l-4.7-6.25.73-.381c-1.509-5.511-2.947-10.764-4.476-16.353C1359.284,440.55,1358.186,439.085,1358.518,432.77Z",
    transform: "translate(-1350.858 -393.474)",
    fill: "#4A4A4A"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11720",
    "data-name": "Path 11720",
    d: "M1330.191,440.689a46.693,46.693,0,0,0,4.9-2.541c8.363-5.759,16.656-11.622,25.017-17.383,2.64-1.819,4.853-3.917,2.612-7.141s-5.025-1.842-7.623-.027c-8.7,6.079-17.522,12-26.072,18.291-1.374,1.01-2.144,3.571-2.155,5.422C1326.867,438.386,1328.925,439.475,1330.191,440.689Z",
    transform: "translate(-1317.413 -393.474)",
    fill: "#4A4A4A"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11721",
    "data-name": "Path 11721",
    d: "M1319.152,472.885h-95.189l-.009,1.782c31.717.11,63.434.06,95.152.017Z",
    transform: "translate(-1169.997 -393.474)",
    fill: "#F26A1B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11722",
    "data-name": "Path 11722",
    d: "M1315.721,428.042c-.269,3.241,17.382,29.737,23.322,35.657C1339.96,461.456,1323,435.38,1315.721,428.042Z",
    transform: "translate(-1281.689 -393.474)",
    fill: "#4A4A4A"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11723",
    "data-name": "Path 11723",
    d: "M1254.163,459.69H1296.3l.024-.842h-42.166Z",
    transform: "translate(-1177.373 -393.474)",
    fill: "#4e5260"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11724",
    "data-name": "Path 11724",
    d: "M1295.715,431.863V406.339c-8.332,0-16.426-.077-24.514.11a3.667,3.667,0,0,0-2.509,2.4c-1.443,7.509-2.641,15.064-3.983,23.012Zm-18.652-24.591,2.518.53c-1.706,7.724-1.846,15.8-5.616,23.066A125.27,125.27,0,0,1,1277.063,407.272Zm7.894,23.189-1.376-.246q1.889-11.246,3.779-22.49l1.444.257Z",
    transform: "translate(-1187.315 -393.474)",
    fill: "#4A4A4A"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVehicle6);
export default __webpack_public_path__ + "static/media/vehicle-6.d669411c87604cd5105371ca2d5d801f.svg";
export { ForwardRef as ReactComponent };